import { useEffect } from "react";

export default function useExternalScripts(props: { url: string, isAsync: boolean, type: string,  }) {
  const { url, type, isAsync } = props;
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.setAttribute("src", url);
    script.setAttribute("type", type);
    script.setAttribute("async", String(isAsync));
    head!.appendChild(script);

    return () => {
      head!.removeChild(script);
    };
  }, [url, type, isAsync]);
}
